module.exports = __webpack_public_path__ + "static/logo_asa-3c4edc91fafb3ccb72579fc66e0d6f48.png";